import { defineMessage } from 'services/localization';

export const messages = {
    documentTitle: defineMessage('title_approvalmax'),
    defaultDocumentTitle: defineMessage('approvalmax_cloud_appro__finance_and_accounting'),
};
